import Tone from 'tone';
import Colors from 'components/Colors.js';
import {MIDI_FX} from 'constants/effect-types.js';
import {AudioParamPercentageValueParameter,
        AudioParamValueParameter} from 'parameters/AbstractAudioParamParameter.js';
import {AbstractParameter} from 'parameters/AbstractParameter.js';
import {saveParameterToJson, loadParameterFromJson}  from 'parameters/parameterJsonFunctions.js';
import {AUDIO_FX} from 'constants/effect-types.js';

const colors = new Colors();

class EffectEdge {
    constructor(effect, sequencerEngine, outputNumber=0) {
        this.parameters = [];
        this.effect = effect;
        this.sequencerEngine = sequencerEngine;
        this.store = sequencerEngine.store;
        this.gain = new Tone.Gain(1);
        this.gainParameter = new AudioParamValueParameter(
            'Gain', this.gain.gain, {
                min: 0,
                max: 1,
                unit: 'db',
                defaultValue: 1
            });
        this.registerParameter(this.gainParameter);

        this.probabilityParameter = new AbstractParameter(
            'Probability', this, () => [], {
                min: 0,
                max: 100,
                unit: '%',
                defaultValue: 100
            });
        this.registerParameter(this.probabilityParameter);

        if (effect && effect.connect) {
            if (effect.effectNode) {
                this.gain.connect(effect.effectNode);
            } else {
                this.gain.connect(effect);
            }
        }

        this.outputNumber = outputNumber;
    }

    getWeight(rack, color) {
        if (rack.getEffectType() === MIDI_FX) {
            return this.probability / 100.0;
        } else {
            return this.gainParameter.get();
        }
    }

    get probability() {
        return this.probabilityParameter.get();
    }

    registerParameter(parameter) {
        if (parameter !== undefined) {
            parameter.name = parameter.name;
            parameter.effectName = this.name;
            parameter.setStore(this.store);
            this.parameters.push(parameter);
        }
    }

    getCopy() {
        let edge = new EffectEdge(this.effect, this.sequencerEngine);
        edge.gainParameter.set(edge.gainParameter.get());
        edge.outputNumber = this.outputNumber;
        return edge;
    }

    getJson(rack) {
        let indexOf = rack.effects.indexOf(this.effect);
        let json = {
            effect: indexOf,
            gain: this.gainParameter ? this.gainParameter.get() : 1,
            probability: this.probability,
            outputNumber: this.outputNumber
        };
        if (this.gainParameter) {
            json = saveParameterToJson(json, 'gainParameter', this.gainParameter);
        }
        json = saveParameterToJson(json, 'probabilityParameter', this.probabilityParameter);
        return json;
    }

    fromJson(json, rack) {
        this.gainParameter.set(json.gain);
        if (json.probability !== undefined) {
            this.probabilityParameter.set(json.probability);
        }
        //if (Tone.Master.context.isOffline) {
            loadParameterFromJson(json, 'gainParameter', this.gainParameter);
        //} else {
         //   setTimeout(() => {
          //      loadParameterFromJson(json, 'gainParameter', this.gainParameter);
           // }, 250);
        // }
        loadParameterFromJson(json, 'probabilityParameter', this.probabilityParameter);
        this.effect = rack.effects[json.effect];
        this.outputNumber = json.outputNumber === undefined ? 0 : json.outputNumber;
        if (!this.effect) {
            this.effect = rack.outputNode;
        }

        if (this.effect.connect === undefined) {
            return;
        }

        if (this.effect.effectNode) {
            this.gain.connect(this.effect.effectNode);
        } else if (this.gain) {
            this.gain.connect(this.effect);
        }
    }

    dispose() {
        if (this.gainParameter) {
            this.gainParameter.dispose();
            this.gainParameter = undefined;
        }
        this._disposed = true;
    }

}

export default EffectEdge;
